import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TvProductionTrackerService } from 'src/app/services/tv-production-tracker.service';
import { GenericService } from 'src/app/services/generic.service';
import { ToastrService } from 'ngx-toastr';
import { videoURL } from 'src/app/services/base-url';

@Component({
  selector: 'app-graphics-workflow',
  templateUrl: './graphics-workflow.component.html',
  styleUrls: ['./graphics-workflow.component.css']
})
export class GraphicsWorkflowComponent implements OnInit {

  statusMap: any = {
    'CREATED': 'Created',
    'EDITOR_ASSIGNED': 'Editor Assigned',
    'EDIT_COMPLETED': 'Edit Completed',
    'TITLE_ASSIGNED': 'Title Assigned',
    'TITLE_COMPLETED': 'Title Completed',
    'GRAPHICS_ASSIGNED': 'Graphics Assigned',
    'GRAPHICS_COMPLETED': 'Graphics Completed',
    'SEO_ASSIGNED': 'SEO Assigned',
    'SEO_COMPLETED': 'SEO Completed',
    'QUALITY_CHECK_ASSIGNED': 'Quality Check Assigned',
    'QUALITY_CHECK_COMPLETED': 'Quality Check Completed',
    'PUBLISHING_ASSIGNED': 'Publishing Assigned',
    'PUBLISHING_COMPLETED': 'Publishing Completed',
    'COMPLETED': 'Completed',
    'PENDING': 'Pending',
    'EPISODE_CREATION': 'Episode Creation'
  };

  episodeList: any = [];
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  tableSize: number = 10;
  isLoading: boolean = false;
  searchFilter: string = "";

  selectedEpisode: any = null;
  graphicsForm: any | FormGroup;
  formSubmit: boolean = false;
  cid: any;
  userType: any = ""
  loggedInUserId: any;

  userList: any[] = [];
  titleUserList: any[] = [];
  selectedUserIdToAssign: any = "";
  videoUrl: any = videoURL


  constructor(
    private tvProductionTrackerService: TvProductionTrackerService,
    private genericService: GenericService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'));
    this.userType = sessionStorage.getItem('userType')
    this.loggedInUserId = Number(sessionStorage.getItem('userId')) || 0;
    this.initForm();
    this.userType = sessionStorage.getItem("userType");
    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }
    this.getAllUsers();
  }

  getAllEpisodes() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllEpisodes().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response.filter((e: any) => e.currentStage === 'GRAPHICS');
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  getAllUsers() {
    this.genericService.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.userList = res.response;
          this.titleUserList = this.userList.filter((u: any) => u.userType === 'DIRECTOR');
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  initForm() {
    this.graphicsForm = this.fb.group({
      graphicsUser: [''],
      assignToGraphicsTeamOnDate: [''],
      graphicsCreationStartDate: [''],
      graphicsCreationEndDate: [''],
      commonNotes: ['']
    });
  }

  getAllTvProductionTrackersUserId() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllTvProductionTrackersUserId(this.loggedInUserId).subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response;
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }
  }

  openGraphicsModal(episode: any) {
    this.selectedEpisode = episode;
    this.graphicsForm.patchValue({
      ...episode,
      commonNotes: ''
    });
    this.formSubmit = false;
    this.selectedUserIdToAssign = "";
  }

  closeModal() {
    document.getElementById("closeGraphicsModalBtn")?.click();
    this.selectedEpisode = null;
    this.graphicsForm.reset();
    this.selectedUserIdToAssign = "";
  }

  saveDetails(complete: boolean) {
    if (this.graphicsForm.invalid) {
      this.formSubmit = true;
      this.toastr.error("Please fill required fields");
      return;
    }

    let commonNotesArr = this.selectedEpisode.commonNotes || [];
    if (this.graphicsForm.get('commonNotes').value) {
      commonNotesArr.push({
        userId: Number(sessionStorage.getItem('userId')) || 0,
        userName: sessionStorage.getItem('userName') || '',
        commonNotes: this.graphicsForm.get('commonNotes').value,
        date: new Date().getTime()
      });
    }

    let nextStage = this.selectedEpisode.currentStage;
    if (complete && this.selectedUserIdToAssign) {
      nextStage = "TITLE";
    }

    let finalGraphicsEndDate = this.graphicsForm.get('graphicsCreationEndDate')?.value ? new Date(this.graphicsForm.get('graphicsCreationEndDate').value).getTime() : 0;
    let finalNoOfDays = this.graphicsForm.get('noOfDaysToGraphics')?.value || 0;
    let finalNoOfHours = this.graphicsForm.get('noOfHoursToGraphics')?.value || 0;
    let finalGraphicsStartDate = this.graphicsForm.get('graphicsCreationStartDate')?.value ? new Date(this.graphicsForm.get('graphicsCreationStartDate').value).getTime() : this.selectedEpisode.graphicsCreationStartDate;

    if (complete) {
      finalGraphicsEndDate = new Date().getTime();
      if (finalGraphicsStartDate) {
        const diffMs = finalGraphicsEndDate - finalGraphicsStartDate;
        finalNoOfDays = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));
        finalNoOfHours = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60)));
      }
    }

    const payload: any = {
      ...this.selectedEpisode,
      commonNotes: commonNotesArr,
      suggestedTitles: this.selectedEpisode.suggestedTitles || [],
      suggestedSEOTitles: this.selectedEpisode.suggestedSEOTitles || [],
      graphicsUser: this.graphicsForm.get('graphicsUser').value,
      assignToGraphicsTeamOnDate: this.graphicsForm.get('assignToGraphicsTeamOnDate').value ? new Date(this.graphicsForm.get('assignToGraphicsTeamOnDate').value).getTime() : (this.selectedEpisode.assignToGraphicsTeamOnDate || 0),
      graphicsCreationStartDate: finalGraphicsStartDate || 0,
      graphicsCreationEndDate: finalGraphicsEndDate,
      noOfDaysToGraphics: finalNoOfDays,
      noOfHoursToGraphics: finalNoOfHours,
      episodeStatus: complete ? 'GRAPHICS_COMPLETED' : this.selectedEpisode.episodeStatus,
      currentStage: nextStage,
      titleCreationUser: (complete && this.selectedUserIdToAssign) ? this.selectedUserIdToAssign : this.selectedEpisode.titleCreationUser,
      assignedUserId: (complete && this.selectedUserIdToAssign) ? Number(this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId || 0) : (this.selectedEpisode.assignedUserId || 0),
      assignToTitleTeamOnDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() : this.selectedEpisode.assignToTitleTeamOnDate,
      titleCreationStartDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() : this.selectedEpisode.titleCreationStartDate,
      titleDueDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() + (2 * 24 * 60 * 60 * 1000) : this.selectedEpisode.titleDueDate,
      cid: this.cid
    };
    delete payload.episodeNotes;
    delete payload.editorNotes;
    delete payload.titleNotes;
    delete payload.graphicsNotes;
    delete payload.seoNotes;
    delete payload.qualityCheckNotes;
    delete payload.publishingNotes;

    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.toastr.success(res.message || 'Workflow updated successfully');
        if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
          this.getAllEpisodes();
        } else {
          this.getAllTvProductionTrackersUserId();
        }
        this.closeModal();
      },
      (err: any) => {
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Error updating workflow');
      }
    );
  }

  isMyNote(note: any): boolean {
    if (!note || note.userId === undefined || note.userId === null) return false;
    return Number(note.userId) === Number(this.loggedInUserId);
  }

  sendChat() {
    const noteText = this.graphicsForm.get('commonNotes')?.value;
    if (!noteText) {
      return;
    }

    const payload = {
      userId: Number(sessionStorage.getItem('userId')) || 0,
      userName: sessionStorage.getItem('userName') || '',
      commonNotes: noteText,
      date: new Date().getTime()
    };

    this.tvProductionTrackerService.updateCommonNotes(this.selectedEpisode.tvProductionTrackerId, payload).subscribe(
      (res: any) => {
        let commonNotesArr = this.selectedEpisode.commonNotes || [];
        commonNotesArr.push(payload);
        this.selectedEpisode.commonNotes = commonNotesArr;
        this.graphicsForm.patchValue({ commonNotes: '' });
      },
      (err: any) => {
        this.toastr.error('Error sending chat');
      }
    );
  }
}
